// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__Z9eQx","colCheckbox":"styles_colCheckbox__2nP6h"};